var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1597.09 1155.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LogoMadesigle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ecriture"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M767.84,351.43v203a2.59,2.59,0,0,1-2.6,2.6H728.81a2.6,2.6,0,0,1-2.61-2.6V393.06a2.6,2.6,0,0,0-2.6-2.61H603.91a2.61,2.61,0,0,0-2.61,2.61V554.39a2.59,2.59,0,0,1-2.6,2.6H562.28a2.6,2.6,0,0,1-2.61-2.6v-203a2.61,2.61,0,0,1,2.61-2.61h203A2.6,2.6,0,0,1,767.84,351.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M809.48,351.43v203a2.59,2.59,0,0,0,2.6,2.6H848.5a2.6,2.6,0,0,0,2.61-2.6V476.33a2.61,2.61,0,0,1,2.61-2.61H973.4a2.61,2.61,0,0,1,2.61,2.61v78.06a2.59,2.59,0,0,0,2.6,2.6H1015a2.6,2.6,0,0,0,2.6-2.6v-203a2.61,2.61,0,0,0-2.6-2.61h-203A2.6,2.6,0,0,0,809.48,351.43ZM973.4,432.09H853.72a2.61,2.61,0,0,1-2.61-2.61V393.06a2.61,2.61,0,0,1,2.61-2.61H973.4a2.61,2.61,0,0,1,2.61,2.61v36.42A2.61,2.61,0,0,1,973.4,432.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 892.74,
    y: 515.35,
    width: 41.63,
    height: 41.64,
    rx: 3.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.11,642.87v36.42a2.6,2.6,0,0,0,2.61,2.6H1015a2.61,2.61,0,0,1,2.6,2.61v36.42a2.61,2.61,0,0,1-2.6,2.61H853.72a2.6,2.6,0,0,0-2.61,2.6v36.42a2.61,2.61,0,0,0,2.61,2.61H1015a2.61,2.61,0,0,1,2.6,2.6v36.43a2.6,2.6,0,0,1-2.6,2.6h-203a2.59,2.59,0,0,1-2.6-2.6v-203a2.59,2.59,0,0,1,2.6-2.6h203a2.6,2.6,0,0,1,2.6,2.6v36.42a2.61,2.61,0,0,1-2.6,2.61H853.72A2.61,2.61,0,0,0,851.11,642.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 642.94,
    y: 432.09,
    width: 41.63,
    height: 124.91,
    rx: 2.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M559.67,601.23v36.42a2.61,2.61,0,0,0,2.61,2.61H598.7a2.6,2.6,0,0,1,2.6,2.61V762.55a2.6,2.6,0,0,1-2.6,2.61H562.28a2.61,2.61,0,0,0-2.61,2.6v36.43a2.6,2.6,0,0,0,2.61,2.6h203a2.59,2.59,0,0,0,2.6-2.6v-203a2.59,2.59,0,0,0-2.6-2.6h-203A2.6,2.6,0,0,0,559.67,601.23ZM723.6,765.16H645.54a2.6,2.6,0,0,1-2.6-2.61V642.87a2.6,2.6,0,0,1,2.6-2.61H723.6a2.6,2.6,0,0,1,2.6,2.61V762.55A2.6,2.6,0,0,1,723.6,765.16Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.b2b39b1eb241b1137affff200ee5494a.svg";
export { ForwardRef as ReactComponent };